const formatAmount = (value: number): string => `$${value.toFixed(2)}`;

export default formatAmount;
